import { InputAdornment, Typography } from '@mui/material';

import { FormAwarePhoneNumberInput } from '@/components/form/formAwareInputs/FormAwarePhoneNumberInput';
import { FormAwareSelectInput } from '@/components/form/formAwareInputs/FormAwareSelectInput';
import { FormAwareTextInput } from '@/components/form/formAwareInputs/FormAwareTextInput';
import { ModalFormLayout } from '@/components/form/layout/ModalFormLayout';
import { Mail01Icon } from '@/components/icons/Mail01Icon';
import { Card } from '@/components/layout/Card/Card';
import { FormLayoutItem, FormLayoutRow } from '@/components/layout/FormLayout';
import { useFormContext } from '@/components/react-hook-form';

import { HouseholdPermissionAwareDisabledProvider } from '../authentication/context/HouseholdPermissionAwareDisabledProvider/HouseholdPermissionAwareDisabledProvider';
import {
  CLIENT_ORGANIZATION_KIND_OPTIONS,
  ClientOrganizationFormShape,
} from './ClientOrganizationModal.constants';

export function ClientOrganizationForm() {
  const { control } = useFormContext<ClientOrganizationFormShape>();
  return (
    <HouseholdPermissionAwareDisabledProvider>
      <ModalFormLayout>
        <FormLayoutRow>
          <FormLayoutItem>
            <FormAwareTextInput<ClientOrganizationFormShape>
              control={control}
              fieldName="name"
              label="Organization name"
              required
            />
          </FormLayoutItem>
        </FormLayoutRow>
        <FormLayoutRow>
          <FormLayoutItem>
            <FormAwareSelectInput<ClientOrganizationFormShape>
              control={control}
              label="Type of organization"
              fieldName="kind"
              options={CLIENT_ORGANIZATION_KIND_OPTIONS}
              required
            />
          </FormLayoutItem>
        </FormLayoutRow>
        <FormLayoutRow>
          <FormLayoutItem width={6}>
            <FormAwareTextInput<ClientOrganizationFormShape>
              control={control}
              fieldName="address.cityName"
              label="City"
            />
          </FormLayoutItem>
          <FormLayoutItem width={6}>
            <FormAwareTextInput<ClientOrganizationFormShape>
              control={control}
              fieldName="address.stateCode"
              label="State"
            />
          </FormLayoutItem>
        </FormLayoutRow>
        <FormLayoutRow>
          <FormLayoutItem>
            <Card variant="filled" sx={{ p: 2 }}>
              <Typography variant="title-s" component="h3" mb={1}>
                Point of contact
              </Typography>
              <FormLayoutRow>
                <FormLayoutItem width={6}>
                  <FormAwareTextInput
                    control={control}
                    label="First name"
                    fieldName={`pointOfContactName`}
                  />
                </FormLayoutItem>
                <FormLayoutItem width={6}>
                  <FormAwareTextInput
                    control={control}
                    label="Last name"
                    fieldName={`pointOfContactLastName`}
                  />
                </FormLayoutItem>
              </FormLayoutRow>
              <FormLayoutRow>
                <FormLayoutItem width={7}>
                  <FormAwareTextInput
                    control={control}
                    label="Email"
                    type="email"
                    fieldName={`pointOfContactEmail`}
                    startAdornment={
                      <InputAdornment position="start">
                        <Mail01Icon size={16} />
                      </InputAdornment>
                    }
                  />
                </FormLayoutItem>
                <FormLayoutItem width={5}>
                  <FormAwarePhoneNumberInput
                    control={control}
                    label="Phone"
                    fieldName={`pointOfContactPhone`}
                  />
                </FormLayoutItem>
              </FormLayoutRow>
            </Card>
          </FormLayoutItem>
        </FormLayoutRow>
      </ModalFormLayout>
    </HouseholdPermissionAwareDisabledProvider>
  );
}
